export default "__VITE_ASSET__G3lWuC6c__"